import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faTwitter, faInstagram, faLinkedin } from '@fortawesome/free-brands-svg-icons';
import './Footer.css';

const Footer = () => {
    const { t } = useTranslation();
    const currentYear = new Date().getFullYear();

    return (
        <footer className="site-footer">
            <Container>
                <Row className="py-5">
                    <Col md={4} className="footer-about mb-4">
                        <h4>دليل التشطيب</h4>
                        <p>منصة دليل التشطيبات توفر لك أفضل شركات التشطيب والتجديد في مصر، مع ضمان جودة الخدمات وسهولة التواصل.</p>
                    </Col>
                    <Col md={4} className="footer-links mb-4">
                        <h4>روابط مهمة</h4>
                        <ul className="list-unstyled">
                            <li><Link to="/">{t('home')}</Link></li>
                            <li><Link to="/about">{t('about')}</Link></li>
                            <li><Link to="/companies">{t('companies')}</Link></li>
                            <li><Link to="/blog">{t('blog')}</Link></li>
                            <li><Link to="/contact">{t('contactUs')}</Link></li>
                        </ul>
                    </Col>
                    <Col md={4} className="footer-contact mb-4">
                        <h4>{t('contactUs')}</h4>
                        <p>القاهرة، مصر</p>
                        <p>info@tashteeb.com</p>
                        <p>01034016811</p>
                        <div className="social-icons">
                            <a href="https://www.facebook.com/share/15Xwfek9QXY/" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faFacebook} /></a>
                            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faTwitter} /></a>
                            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faInstagram} /></a>
                            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FontAwesomeIcon icon={faLinkedin} /></a>
                        </div>
                    </Col>
                </Row>
                <hr />
                <Row>
                    <Col className="text-center py-3">
                        <p>{t('copyright')} {currentYear} © دليل التشطيبات | تم التطوير بواسطة <a href="https://adams-agency.online" target="_blank" rel="noopener noreferrer" style={{ color: '#ff6b35', textDecoration: 'none' }}>Adam's Agency</a></p>
                        <div className="footer-sub-links">
                            <Link to="/privacy-policy">{t('privacyPolicy')}</Link>
                            <Link to="/terms-of-service">{t('termsOfService')}</Link>
                        </div>
                    </Col>
                </Row>
            </Container>
        </footer>
    );
};

export default Footer;
